export enum LoginWithGoogleReturnPath {
  LOGIN = "LOGIN",
  SIGNUP = "SIGNUP",
  CALLBACK = "CALLBACK",
}
